<!--<button class="btn btn-primary btn-block" (click)="launchRipple()">test ripple</button>-->

<div class="animated faster fadeInUp ac-color">
    <div matRipple #ticketRipple matRippleDisabled="true">

        @if ($storage.hasOffers) {
        @if ($storage.enablePay && $storage.order.checks) {
        <app-tabitpay-ticket-checks [$storage]="$storage" (onCheckSelect)="_onCheckSelect($event)"></app-tabitpay-ticket-checks>
        } @else {
        <app-tabitpay-ticket-seated [$storage]="$storage" [workMode]="'inline'" (onTicketAction)="onTicketAction($event)"></app-tabitpay-ticket-seated>
        }


        } @else {
        <div class="p-3">
            <div class="my-panel no-shadow">
                <div class="my-panel-body ">
                    <div style="font-weight: 600;">
                        {{'PO.ORDER_NO' | translate}}:&nbsp;{{$storage.order?._order?.number}}
                    </div>
                    <div class="text-accent">
                        {{'preparing-food' | translate}}
                    </div>
                    <ng-container *ngIf="$storage.enableAddItems">
                        <button mat-flat-button color="accent" class="lg main-continue-btn mt-4" type="button" (click)="appService.addItemsToOrder()">
                            <div class="_inner" style="justify-content:center">
                                <div>{{'add-items' | translate}}</div>
                            </div>
                        </button>
                    </ng-container>

                    <lottie-anim [options]="{animation: 'gears', autoplay: true, loop: true }" [height]="300"></lottie-anim>
                </div>
            </div>
        </div>
        }
    </div>
</div>



@if (!$storage.restricted && !$storage.order.checks && !$storage.order.closed) {
<div class="p-3 pb-4 fixed-bottom animated fadeInUp">

	@if (!$storage.hasOffers && $storage.order.isTabOwner) {
		<button mat-stroked-button color="accent" class="lg rounded btn-block mt-2" type="button" (click)="manageTab()">
			{{ 'OAT.manage-tab-order' | translate }}
		</button>
	}

	@if ($storage.hasOffers && $storage.enableAddItems) {
		<button mat-raised-button color="primary" class="lg main-continue-btn mt-2" type="button"
				(click)="appService.addItemsToOrder()">
			<div class="_inner" style="justify-content:center">
				<div>{{ 'add-items' | translate }}</div>
			</div>
		</button>
	}

	@if ($storage.enablePay && $storage.order.canPay) {
		<button mat-raised-button color="accent" class="lg main-continue-btn mt-2" type="button"
				(click)="_continue()">
			<div class="_inner" style="justify-content:center">
				<div>{{ 'goto-payment' | translate }}</div>
			</div>
		</button>
	}

	<!--<ng-container *ngIf="$storage.showPrices && $storage.hasOffers && !$storage.enablePay">
		<button mat-raised-button color="accent" class="lg rounded btn-block mt-2" type="button" (click)="_continue('full_tip')">
			{{'goto-tip' | translate}}
		</button>
	</ng-container>-->

</div>
}

<div class="spacer-bottom"></div>
